import { Component, Input, OnInit } from '@angular/core';
import { filter } from 'lodash';
import { combineLatest, Observable, Subject } from 'rxjs';
import { unsubscribeComponent } from '../../../shared/helpers/unsubscribe-decorator/unsubscribe-decorators.helper';
import { FlagsFilterService } from '../../../shared/services/filter-services/flags-filter.service';
import {
  ICollectionToMerge,
  StudentCollectionsMergeService,
} from '../../../shared/services/student-collections-merge/student-collections-merge.service';
import { IFlag } from '../../../shared/typings/interfaces/flags.interface';
import { IStudentSupport } from '../../../shared/typings/interfaces/student-support.interface';
import { IStudent } from '../../../shared/typings/interfaces/student.interface';
import { IAttendanceListStudent } from '../../../store/effects/projections';

@Component({
  selector: 'nvps-attendance-list',
  template: require('./attendance-list.component.html'),
})
@unsubscribeComponent
export class AttendanceListComponent implements OnInit {
  public studentsWithFlagsAndSupports$: Observable<any>;
  public destroy$: Subject<boolean> = new Subject<boolean>();

  @Input() flags$: Observable<IFlag[]>;
  @Input() studentSupports$: Observable<IStudentSupport[]>;
  @Input() students$: Observable<IStudent[]>;
  @Input() currentSchool: any;
  @Input() currentUser: any;
  @Input() madlibOptions$: any;
  @Input() madlibState$;
  @Input() batchActionsMode$: Observable<any>;

  constructor(
    private flagsFilterService: FlagsFilterService,
    private studentCollectionsMergeService: StudentCollectionsMergeService,
  ) {}

  ngOnInit(): void {
    this.studentsWithFlagsAndSupports$ = this.mergeStudentsAndCollections(
      this.students$,
      this.flags$,
      this.studentSupports$,
    );
  }

  getFilteredActiveStudentSupports(studentSupports: IStudentSupport[]) {
    return filter(studentSupports, (studentSupport: IStudentSupport) => {
      return studentSupport.status === 'ACTIVE';
    });
  }

  mergeStudentsAndCollections(
    students$: Observable<IStudent[]>,
    flags$: Observable<IFlag[]>,
    studentSupports$: Observable<IStudentSupport[]>,
  ): Observable<IAttendanceListStudent[]> {
    return combineLatest(
      students$,
      flags$,
      studentSupports$,
      (students: IStudent[], flags: IFlag[], studentSupports: IStudentSupport[]) => {
        flags = this.flagsFilterService.getFilteredFlags(flags, 'ATTENDANCE');
        const activeStudentSupports = this.getFilteredActiveStudentSupports(studentSupports);

        const studentsWithMergedCollections = this.studentCollectionsMergeService.mergeCollectionsToStudents({
          students,
          collections: [
            {
              collection: flags,
              keyToAddToStudent: 'flags',
              pathToStudentId: 'studentId',
            } as ICollectionToMerge,
            {
              collection: activeStudentSupports,
              keyToAddToStudent: 'activeStudentSupports',
              pathToStudentId: 'student.studentId',
            } as ICollectionToMerge,
          ],
        });

        return studentsWithMergedCollections;
      },
    );
  }
}
